import Slider from './slider';
import ErrorHandling from './error-handling';
import RequiredInputValidation from './required-input-validation';
import FormHelpers from './form-helpers';
import ValidateEmail from './validate-email';
import Helpers from './helpers';

const Wizard = {
	init() {
		this.currentTab = 0;
		this.tabs = document.getElementsByClassName('wizard__fiedset');
		this.progressBar = document.getElementById('progressBarForm');
		this.formBar = document.getElementById('formBarActions');
		if (
			document.querySelector('[data-form-validation]') &&
			document.querySelector('[data-form-validation]').dataset.formValidation === 'buttonDisabled'
		) {
			this.formValidationButtonDisabled = true;
		}
		this.isReviewForm = document.querySelector('[data-review-form]');
		this.prevBtn = document.getElementById('prevBtn');
		this.nextBtn = document.getElementById('nextBtn');
		this.initialBtnText = this.nextBtn?.dataset?.initialBtnText;
		this.submitBtnText = this.nextBtn?.dataset?.submitBtnText;
		this.regularBtnText = this.nextBtn?.value;
		if (this.tabs != null && this.tabs.length > 0 && this.nextBtn != null) {
			this.showTab();
			this.initEvents();
		}
	},

	initEvents() {
		if (this.prevBtn != null) {
			this.prevBtn.addEventListener('click', (e) => {
				e.preventDefault();
				this.nextPrev(-1);
			});
		}
		this.nextBtn.addEventListener('click', (e) => {
			const currentTabContainer = this.tabs[this.currentTab];
			e.preventDefault();
			if (FormHelpers.missingInputCheck(currentTabContainer, e)) {
				this.nextPrev(1);
			}
		});
	},

	showTab() {
		this.tabs[this.currentTab].style.display = 'block';
		this.tabs[this.currentTab].scrollIntoView({
			behavior: 'smooth',
			block: this.isReviewForm ? 'center' : 'start',
			inline: 'nearest',
		});

		// set the progressbar
		if (this.progressBar) {
			FormHelpers.setProgressBar(this.progressBar, this.currentTab, this.tabs);
		}

		// need to refresh the codemirror textarea as it's not correctly initialized when hidden
		document.querySelectorAll('.CodeMirror').forEach((el) => {
			el.CodeMirror.refresh();
		});
		// ... and fix the Previous/Next buttons:

		if (this.prevBtn != null) {
			if (this.currentTab === 0) {
				this.prevBtn.style.display = 'none';
				if (this.formBar) {
					this.formBar.classList.add('flex--justify-end');
					this.formBar.classList.remove('flex--space-between');
				}
			} else {
				this.prevBtn.style.display = 'block';
				if (this.formBar) {
					this.formBar.classList.remove('flex--justify-end');
					this.formBar.classList.add('flex--space-between');
				}
			}
		}
		if (this.initialBtnText && this.currentTab === 0) {
			this.nextBtn.value = this.initialBtnText;
		}
		if (this.submitBtnText && this.currentTab === this.tabs.length - 1) {
			this.nextBtn.value = this.submitBtnText;
		}
		if (this.regularBtnText && this.currentTab !== this.tabs.length - 1 && this.currentTab !== 0) {
			this.nextBtn.value = this.regularBtnText;
		}
		if (document.getElementsByClassName('wizard__step').length > 0) {
			this.setStepIndicator();
		}
		if (document.querySelectorAll('.wizard__counter').length > 0) {
			FormHelpers.tabCounter(this.tabs.length, this.currentTab);
		}
		if (this.tabs[this.currentTab].querySelectorAll('[data-slider]')) {
			// eslint-disable-next-line no-new
			new Slider({
				elements: this.tabs[this.currentTab].querySelectorAll('[data-slider]'),
			});
		}
		if (this.formValidationButtonDisabled) {
			Helpers.disableAllButtons();
			this.formRequiredInputValidation();
		}
		Wizard.clearTabInputsOnRadioButtonChange();
	},

	async emailValidation(form) {
		this.continue = true;
		Helpers.disableAllButtons();
		if (form.dataset?.apiEndpoint) {
			const formSubmit = new ValidateEmail();
			const submitResponse = formSubmit.validateEmail(form);
			this.continue = submitResponse;
		}
		Helpers.enableAllButtons();
		return this.continue;
	},

	async nextPrev(n) {
		// This function will figure out which tab to display
		// Exit the function if any field in the current tab is invalid:
		if (!this.formValidationButtonDisabled) {
			if (n === 1 && !this.validateForm()) return false;
		}
		if (this.tabs[this.currentTab].querySelectorAll('[data-email-check]').length > 0) {
			const elements = this.tabs[this.currentTab].querySelectorAll('[data-email-check]');
			await elements.forEach((el) => {
				this.emailValidation(el);
			});
			if (this.continue === false) {
				return false;
			}
		}

		// Hide the current tab:
		if (this.currentTab + 1 < this.tabs.length || n === -1) {
			this.tabs[this.currentTab].style.display = 'none';
		}
		// Increase or decrease the current tab by 1:
		this.currentTab += n;
		// if you have reached the end of the form... :
		if (this.currentTab >= this.tabs.length) {
			// ...the form gets submitted:
			window.dispatchEvent(new CustomEvent('submit-form'));

			// Check if a lightbox needs to be dispatched on save
			this.handleDispatchLightBox();

			// reset current tab to last one
			this.currentTab -= 1;
			return false;
		}
		// Otherwise, display the correct tab:
		this.showTab(this.currentTab);
		FormHelpers.validateImageUploadExtension(this.tabs[this.currentTab]);
		return false;
	},

	formRequiredInputValidation() {
		const inputs = this.tabs[this.currentTab]?.querySelectorAll('input, textarea, select');
		inputs.forEach((input) =>
			input.addEventListener('change', () => {
				RequiredInputValidation.checkForm(inputs);
			})
		);
	},

	clearTabInputsOnRadioButtonChange() {
		const inputs = this.tabs[this.currentTab]?.querySelectorAll('input, textarea, select');
		inputs.forEach((input) => {
			if (input.type === 'radio') {
				input.addEventListener('change', (e) => {
					Wizard.clearInputs(e);
				});
			}
		});
	},

	clearInputs(e) {
		const name = e.target.getAttribute('name');
		if (name != null) {
			const targetElements = document.querySelectorAll(`[data-target="${name}"]`);
			targetElements.forEach((el) => {
				const inputs = el.querySelectorAll('input, textarea, select');
				for (let i = 0; i < inputs.length; i += 1) {
					switch (inputs[i].type) {
						case 'checkbox':
							if (inputs[i].checked) {
								inputs[i].checked = false;
							}
							break;
						default:
							if (inputs[i].value) {
								inputs[i].value = '';
							}
					}
				}
			});
		}
	},

	validateForm() {
		let valid = true;
		const inputs = this.tabs[this.currentTab]?.querySelectorAll('input, textarea, select');
		// A loop that checks every input field in the current tab:
		valid = ErrorHandling(inputs);
		return valid; // return the valid status
	},

	setStepIndicator() {
		// This function removes the "wizard__step--active" class of all steps...
		const steps = document.getElementsByClassName('wizard__step');
		for (let i = 0; i < steps.length; i += 1) {
			steps[i].className = steps[i].className.replace(' wizard__step--active', '');
		}
		// ... and adds the "wizard__step--active" class to the current step:
		steps[this.currentTab].className += ' wizard__step--active';
	},

	getStep() {
		return this.currentTab;
	},

	handleDispatchLightBox() {
		if (this.nextBtn?.dataset?.lightboxId) {
			const templateId = this.nextBtn.dataset.lightboxId;

			window.dispatchEvent(
				new CustomEvent('lightbox-show-by-template-id', {
					detail: {
						templateId,
					},
				})
			);
		}
	},
};

export { Wizard as default };
